import { render, staticRenderFns } from "./WebhookList.vue?vue&type=template&id=b36245e8&scoped=true"
import script from "./WebhookList.vue?vue&type=script&lang=js"
export * from "./WebhookList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36245e8",
  null
  
)

export default component.exports